import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Catches the browser's install prompt as soon as it's offered (Settings → Install app).
import './lib/install';
import './styles/index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => console.warn('[sw] registration failed', err));
  });
}
